import * as React from 'react';
import { Route } from 'react-router-dom';
import get from 'lodash/get';
import withAuthentication from 'components/withAuthentication';
import LoadingPage from 'pages/LoadingPage';
import NotFoundPage from 'pages/NotFoundPage/NotFoundPage';
import LoginPage from '../LoginPage';
import DetailsBookingProvider from 'components/DetailsBookingProvider';
import LiveChat from 'components/LiveChat/LiveChat';

class BookingAccessRoute extends React.Component {
  componentDidMount() {
    const bookingId = this.getBookingId();
    this.props.retrieveBookingAuthMethod({ bookingId });
  }

  getBookingId() {
    return get(this.props, 'computedMatch.params.bookingId');
  }

  render() {
    const {
      component: Component,
      hasFetchedBookingAuthMethod,
      isAuthenticated,
      isSSO,
      authMethod,
      hasInitializedSSO,
      ...routeProps
    } = this.props;
    const bookingId = this.getBookingId();

    return (
      <Route
        {...routeProps}
        render={(props) => {
          if (authMethod === 'unknown') {
            return <NotFoundPage />;
          }

          if (!hasFetchedBookingAuthMethod) {
            return <LoadingPage />;
          }

          if (!isAuthenticated) {
            return <LoginPage data-testid="login-form" isSSO={isSSO} hasInitializedSSO={hasInitializedSSO} bookingId={bookingId} />;
          }

          return (
            <DetailsBookingProvider>
              <Component {...props} isSSO={isSSO} />
              <LiveChat />
            </DetailsBookingProvider>
          );
        }}
      />
    );
  }
}

export default withAuthentication(BookingAccessRoute);
